/**
 * DevExtreme (ui/data_grid/ui.data_grid.grid_view.js)
 * Version: 18.2.4
 * Build date: Mon Dec 17 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var gridCore = require("./ui.data_grid.core"),
    gridViewModule = require("../grid_core/ui.grid_core.grid_view");
gridCore.registerModule("gridView", gridViewModule);



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/devextreme/ui/data_grid/ui.data_grid.grid_view.js
// module id = ../../../../devextreme/ui/data_grid/ui.data_grid.grid_view.js
// module chunks = common